import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿Qué pasa si estoy listo para comprar ahora mismo?',
    answer: 'Si estás listo para comprar, puedes visitar nuestra tienda directamente para adquirir tus leads de inmediato.',
    link: {
      text: 'Comprar Leads Ahora →',
      url: 'https://xclusiveagentleads.com/collections/todos-los-leads'
    }
  }, {
    question: '¿Cuánto tiempo tarda en activarse mi campaña después de hacer la compra?',
    answer: 'Tu campaña se activa dentro de las primeras 24-48 horas después de completar tu compra. Recibirás una confirmación por correo electrónico y WhatsApp una vez que esté activa.'
  }, {
    question: '¿Cómo recibo mis leads si uso GoHighLevel (GHL)?',
    answer: 'Si usas GoHighLevel, los leads se integran directamente a tu CRM en tiempo real. Los recibirás automáticamente en tu pipeline de GHL listos para que los contactes.'
  }, {
    question: '¿Qué pasa si no uso GHL? ¿Cómo recibo mis leads?',
    answer: 'Si no usas GoHighLevel, no te preocupes. Puedes recibir tus leads por mensaje de texto (SMS), WhatsApp, o correo electrónico directamente a tu teléfono en tiempo real.'
  }, {
    question: '¿Cómo puedo ver mi lista completa de leads?',
    answer: 'Puedes ver tu lista completa de leads directamente desde tu panel de GoHighLevel o desde la plataforma que uses para recibirlos. También puedes contactar a nuestro equipo de soporte para obtener un reporte detallado.'
  }, {
    question: '¿Qué debo hacer si mis leads no están llegando?',
    answer: 'Si no estás recibiendo leads, contacta a nuestro equipo de soporte inmediatamente por WhatsApp. Verificaremos tu campaña y resolveremos cualquier problema lo antes posible.'
  }, {
    question: '¿Tienen garantía o reemplazo de leads?',
    answer: 'Sí, ofrecemos garantía en nuestros leads. Si un lead no cumple con los criterios de calidad establecidos, lo reemplazamos sin costo adicional. Tu satisfacción es nuestra prioridad.'
  }];
  return <section id="faq" className="bg-white py-12 md:py-16 px-4" data-id="element-47">
      <div className="max-w-3xl mx-auto" data-id="element-48">
        <div className="text-center mb-10" data-id="element-49">
          <span className="block text-sm font-bold tracking-widest text-brand-orange uppercase mb-4" data-id="element-50">
            Preguntas Frecuentes
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-brand-charcoal text-balance" data-id="element-51">
            Resolvemos Tus Dudas
          </h2>
        </div>

        <div className="space-y-4" data-id="element-52">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="border-b border-gray-200 pb-4" data-id="element-53">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="flex items-center justify-between w-full text-left py-4 focus:outline-none group" aria-expanded={openIndex === index} data-id="element-54">
                <span className="text-lg font-bold text-brand-charcoal group-hover:text-brand-orange transition-colors" data-id="element-55">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform duration-300 ${openIndex === index ? 'rotate-180 text-brand-orange' : ''}`} data-id="element-56" />
              </button>

              <AnimatePresence initial={false} data-id="element-57">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-58">
                    <p className="pb-4 text-gray-600 leading-relaxed pr-8" data-id="element-59">
                      {faq.answer}
                      {faq.link && <>
                          {' '}
                          <a href={faq.link.url} target="_blank" rel="noopener noreferrer" className="inline-block mt-2 text-brand-orange font-bold hover:underline" data-id="element-60">
                            {faq.link.text}
                          </a>
                        </>}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}